import { CreateZoneDto } from "@/core/features/zones/create-zone.dto";

export class UpdateZoneDto extends CreateZoneDto {}
